/**
 *
 * @author Aleynikov Boris <alynikov.boris@gmail.com>.
 */

'use strict';

var LayoutList = require('mag-component-layout-list'),
    keys       = require('stb-keys');

/**
 * Convert data to layout list format.
 *
 * @param {Array} data - data to convert
 * @return {Array} converted data
 */
function normalize ( data ) {
    var result = [],
        index;

    if ( DEVELOP ) {
        if ( !Array.isArray(data) ) { throw new Error(__filename + ': wrong data type'); }
    }

    for ( index = 0; index < data.length; index++ ) {
        result.push({
            click: data[index].click,
            items: [
                {
                    className: data[index].icon,
                    name: '$icon'
                },
                {
                    className: 'title',
                    value: data[index].title,
                    name: '$text'
                }
            ],
            name: data[index].buttonName
        });
    }

    return result;
}


/**
 * Graphite horizontal menu implementation
 *
 * @extends LayoutList
 *
 * @param {Object} config - config object
 * @constructor
 */
function Menu ( config ) {
    config = config || {};

    config.type = LayoutList.prototype.TYPE_HORIZONTAL;

    config.data = normalize(config.data);

    config.className = 'horizontalMenu ' + (config.className || '');

    config.events = {
        keydown: function ( event ) {
            if ( event.code !== keys.pageDown && event.code !== keys.pageUp ) {
                LayoutList.prototype.defaultEvents.keydown.call(this, event);
            }
        }
    };

    LayoutList.call(this, config);

}

Menu.prototype = Object.create(LayoutList.prototype);
Menu.prototype.constructor = Menu;


Menu.prototype.init = function ( config ) {
    config = config || {};
    config.data = normalize(config.data);
    LayoutList.prototype.init.call(this, config);
};


module.exports = Menu;
